import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Text,
} from '@chakra-ui/react';

interface IProps {
  localPickUpOptions: any[];
  loading: boolean;
  onSubmit: (shippingOptionCode: string | undefined) => void;
  handleBack: () => void;
}

export default ({
  handleBack,
  onSubmit,
  localPickUpOptions,
  loading,
}: IProps): React.ReactElement => {
  const { t } = useTranslation();
  const [selectedId, setSelectedId] = useState<ShippingOption['code']>(
    localPickUpOptions?.[0].code,
  );

  const handleChange = (e) => {
    setSelectedId(e.target.value);
  };

  const handleSubmit = () => {
    onSubmit(selectedId);
  };

  return (
    <>
      <ModalHeader>{t('subscription.pick_up_list_title')}</ModalHeader>
      <ModalCloseButton />
      <ModalBody
        style={{
          overflowX: 'hidden',
        }}
      >
        <form id="list-form" className="bundleapp-modal__scroll-content">
          {localPickUpOptions?.length === 0 ? (
            <Text fontSize="md">{t('subscription.no_pick_up_locations')}</Text>
          ) : (
            <Text fontSize="md">{t('subscription.pick_up_list_subtitle')}</Text>
          )}
          {localPickUpOptions?.map(
            ({ location: { address, localPickupSettingsV2 }, ...pickUp }) => (
              <div
                className="bundleapp-flex bundleapp-flex-align-center"
                key={pickUp.code}
                style={{ margin: 20 }}
              >
                <input
                  type="radio"
                  id={`address_${pickUp.code}`}
                  checked={selectedId == pickUp.code}
                  onChange={handleChange}
                  name="address"
                  value={pickUp.code}
                />
                <label
                  style={{ flex: 1, marginLeft: 10 }}
                  htmlFor={`address_${pickUp.title}`}
                >
                  <p style={{ margin: 0 }}>
                    <strong>{pickUp.title}</strong>
                    <br />
                    {address.address1} {address.address2}
                    <br />
                    {address.city}
                    {address.province && `, ${address.province}`}, {address.zip}{' '}
                    <br />
                    {address.country}
                  </p>
                  {localPickupSettingsV2.instructions ? (
                    <Text fontSize="md">
                      {localPickupSettingsV2.instructions}
                    </Text>
                  ) : null}
                </label>
              </div>
            ),
          )}
        </form>
      </ModalBody>
      <ModalFooter>
        <Button mr="4" onClick={handleBack} variant="outlinedBig">
          {t('titles.cancel')}
        </Button>
        <Button
          onClick={handleSubmit}
          isLoading={loading}
          disabled={loading}
          variant="blackBig"
        >
          {t('titles.continue')}
        </Button>
      </ModalFooter>
    </>
  );
};
